import { useAuth0 } from '@auth0/auth0-react';
import type { FC, PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';
import Loading from './Loading';

export const AuthTokenProvider: FC<PropsWithChildren<any>> = ({ children }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [authToken, setAuthToken] = useState<undefined | string>(undefined);

  // Not adding dependencies to this hook is deliberate. We only want to run this once when the component mounts.
  useEffect(() => {
    getAccessTokenSilently().then(setAuthToken);
  }, []);

  if (!authToken) {
    return <Loading />;
  }

  return children({ authToken });
};
